import { ProcAttribGroupsEntity } from "./lookup.model";
import { helpOutline } from "ionicons/icons";
import { InputModeEnum } from "./input-mode.enum";
import { UIElementEnum } from "./ui-element.enum";
import { ValidationAppliesToEnum, ValidationTypeEnum } from "./validation.enum";


export type InputMode = keyof typeof InputModeEnum;

export class Question {
    QuestionID: number = 0
    UIElementID: number = UIElementEnum.unknown;
    UIControlType: number = UIElementEnum.unknown;
    SectionID: number = 0;
    Name: string | undefined;
    Label: string = "";
    ProcAttribID?: number;
    CreatedBy: number = 0;
    Priority: number = 0;
    Icon: any = helpOutline;
    IsActive: boolean = true;
    IsRequired: boolean = false;
    IsLabelHidden: boolean = false;
    ColSpan: number | null = null;
    Meta: string = "{}";
    InputMode: InputMode = InputModeEnum[InputModeEnum.text] as InputMode;
    QuestionOptions: QuestionOption[] = [];
}

export class QuestionOption {
    QuestionOptionID: number = 0
    QuestionID: number = 0
    Name: string | undefined;
    Label: string | undefined;
    Priority: number = 0
    CreatedBy: number = 0
    IsActive: boolean = true;
}

export interface Cols {
    xs: number;
    md: number;
}

export class Section {
    SectionID: number = 0;
    PageID: number = 0;
    Label: string = 'New Section';
    Cols: number = 1;
    Type: string | undefined;
    EditSection: boolean = false;
    IsReorder: boolean = false;
    Priority: number = 1;
    Questions: Question[] = [];
    Conditions: SectionCondition[] | undefined = []
}
export class SectionCondition {
    ActionFieldID: number = 0
    ActionType: string = ''
    ConditionType: string = ''
    ConditionValue: string = ''
    QuestionID: number = 0
    Priority: number = 0
    ConditionID: number = 0
}



export class Page {
    PageID: number = 0;
    PHQID: number = 0;
    Name: string = 'New Page'
    Label: string = 'New Page'
    NextPageId: number = 0;
    // Outlet: string | undefined;
    // OutletBasic: string | undefined;
    // SegmentSelected?: string = 'outlet'
    Collapsed: boolean = true;
    Priority: number = 1;
    Sections: Section[] | null = [];
}

export class QuestionnaireModel {
    PHQID: number = 0;
    Name: string = 'PHQ Name';
    Domain: string = '';
    Label: string = 'PHQ Label';
    Description: string | null = '';
    // TimeZone: string = 'America/New_York'
    IsActive: boolean = true;
    CreatedBy: number = 0;
    CreatedOn: string | null = '';
    UpdatedOn: string | null = '';
    UpdatedBy: number = 0;
    Pages: Page[] | null = [];
    Versions: PHQVersion[] | null = [];
}

export class QuestionnaireCopyModel {
    PHQID: number = 0;
    Label: string = "Copy";
}

export class QuestionnaireGlobalModel {
    SearchedText = '';
    GroupSelected = {} as ProcAttribGroupsEntity;
    Sections = [] as Section[];
    PhqSelected = {} as QuestionnaireModel;
    PageSelected = {} as Page;
    ViewMode: boolean = false;
    ConditionalLogicMode: boolean = false;
    SnapShotID: number = 0;
    CurrentPHQ: string = '';
    IsSnapShot: boolean = false;
    VersionIDViewing: number = 0;
    PhqList = [] as QuestionnaireModel[];
    SelectedSection: Section = {} as Section;
}

export class PHQVersion {
    PHQVersionID: number = 0;
    PHQID: number = 0;
    Description: string = '';
    CreatedBy: number = 0;
    CreatedOn: Date = new Date();
    Status: string = 'Draft'
    IsPublished: boolean = false;
    IsCurrent: boolean = false;
    BaseVersionID: number = 0;
    RawPHQ: string = '';
}

export class Validation {
    ValidationID: number = 0;
    ValidationTypeID: number = 0;
    AppliesTo: string = ''
    AppliesToID: number = 0;
    ValidationLogic: string = '';
    RunAt:string = '';
    CreatedBy: number = 0;
}

export class ValidationToUpdate {
    ValidationID: number = 0;
    ValidationTypeID: number = 0;
    ValidationLogic: string = ''
}

export interface ValidationSearchParams {
    AppliesTo: ValidationAppliesToEnum;
    AppliesToID?: number;
    ValidationTypeID?: ValidationTypeEnum;
}

export class SnapShot {
    SnapshotID: number = 0;
    Action: string = '';
    PHQVersionID: number = 0;
    RawPHQ: string = '';
    CreatedBy: number = 0;
    CreatedOn: Date = new Date();
}

